import { render, staticRenderFns } from "./WebsiteNewsletter.vue?vue&type=template&id=5bbcfd16&scoped=true&"
import script from "./WebsiteNewsletter.vue?vue&type=script&lang=js&"
export * from "./WebsiteNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbcfd16",
  null
  
)

export default component.exports